module.exports = __webpack_public_path__ + "static/media/10.7a84ae93.svg";